class ProductImages extends HTMLElement {
	constructor() {
		super();
		this.reelEl = this.querySelector('.product-images__reel');
		this.reelElWrapperEl = this.querySelector('.product-images__reel-wrapper');
		this.reelItems = this.querySelectorAll('.product-images__reel-item');

		this.featuredImageEl = this.querySelector('.product-images__featured');
		this.featuredImageCaptionEl = this.querySelector('#featuredImageCaption');

		this.renderScrollerUi();
		window.addEventListener('resize', event => {
			this.renderScrollerUi(event);
		});
		this.reelEl.addEventListener('scroll', event => {
			this.renderScrollerUi(event);
		});

		this.reelItems.forEach(item => item.addEventListener('click', this.onReelImageClick.bind(this)));
	}

	renderScrollerUi() {
		const atStart = this.reelEl.scrollTop == 0;
		const atEnd = this.reelEl.scrollHeight - (this.reelEl.scrollTop + this.reelEl.offsetHeight) == 0;

		requestAnimationFrame(() => {
			this.reelElWrapperEl.toggleAttribute('at-start', atStart);
			this.reelElWrapperEl.toggleAttribute('at-end', atEnd);
		});
	}

	onImageLoaded(event) {
		const { target } = event;
		target.classList.remove('loading');


		Array.from(this.featuredImageEl.childNodes).forEach(el => {
			if(el != target) {
				el.remove();
			}
		});
        $('#zoomContainer').zoom({magnify: 1});
	}

	onReelImageClick(event) {
		const { target: el } = event;

		if (el.classList.contains('active')) return;

		const { target: targetEl } = event;

		// scroll thumbnail into middle of reel
		const top = targetEl.offsetTop - (this.reelEl.clientHeight / 2);
		this.reelEl.scrollTo({
			top,
			behavior: 'smooth'
		});


		let { alt, caption, mediaType, mediaSrc } = el.dataset;

		if (mediaType == 'video') {
			let video = document.createElement('video');

			video.addEventListener('loadstart', event => {
				this.onImageLoaded(event);
			});

			video.classList.add('loading');
			video.autoplay = true;
			video.loop = true;
			video.muted = true;
			video.alt = alt;
			video.src = mediaSrc;

			this.featuredImageEl.appendChild(video);

		} else {

			let image = document.createElement('img');

			image.addEventListener('load', event => {
				this.onImageLoaded(event);
			});
			image.classList.add('loading');
			image.src = mediaSrc;
			image.alt = alt;
			this.featuredImageEl.appendChild(image);
		}

		this.featuredImageCaptionEl.innerHTML = caption;


		this.reelItems.forEach(reelItemEl => {
			reelItemEl.classList.toggle('active', reelItemEl == el);
		});
	}
}

customElements.define('product-images', ProductImages);
